import { cx } from '@emotion/css';
import { useAnalytics } from '@/hooks/useAnalytics';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import { BodyMedium, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import styles from './ProgramBanner.styles';
import { AccessibleDivButton } from '@/components';

interface Props {
  name: string;
  description: string;
  illustration: string;
  onClick: (searchType: string) => void;
}

const ProgramBanner: React.FC<Props> = ({
  name,
  description,
  illustration,
  onClick,
}) => {
  const { track } = useAnalytics();
  return (
    <AccessibleDivButton
      className={cx(styles.container)}
      onClick={() => {
        onClick(`New Flyers`);
        track({
          category: `explore_page:banners`,
          action: GenericTrackTypes.BUTTON_PRESSED,
          label: `Explore ${name} flyers`,
        });
      }}
      data-testid="ProgramBanner"
      role='link'
    >
      <div className={styles.illustration}>
        <img
          src={illustration}
          alt=""
          data-testid="illustration"
        />
      </div>
      <div className={styles.content}>
        <TitleSmallEmphasized className={styles.title} data-testid="title">
          {name}
        </TitleSmallEmphasized>
        <BodyMedium color={colors.slate} data-testid="description">
          {description}
        </BodyMedium>
      </div>
    </AccessibleDivButton>
  );
};

export default ProgramBanner;
